/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomefieldPromotionComponent } from './promotion.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HomefieldPromotionComponent],
  exports: [HomefieldPromotionComponent],
})
export class HomefieldPromotionModule {}
